import { getProjectSaveActions } from "../stores/projectSaveStore";

export const JOINT_MARKER_SCALE_EVENT = "joint-marker-scale-percent-changed";
export const JOINT_MARKER_SCALE_STORAGE_KEY = "critter.jointMarkerScalePercent";
export const JOINT_MARKER_SCALE_DEFAULT_PERCENT = 100;
export const JOINT_MARKER_SCALE_MIN_PERCENT = 10;
export const JOINT_MARKER_SCALE_MAX_PERCENT = 300;
export const JOINT_MARKER_SCALE_STEP_PERCENT = 5;

let currentJointMarkerScalePercent = JOINT_MARKER_SCALE_DEFAULT_PERCENT;

export function clampJointMarkerScalePercent(value: number): number {
  if (!Number.isFinite(value)) return JOINT_MARKER_SCALE_DEFAULT_PERCENT;
  return Math.max(
    JOINT_MARKER_SCALE_MIN_PERCENT,
    Math.min(JOINT_MARKER_SCALE_MAX_PERCENT, Math.round(value))
  );
}

function dispatchJointMarkerScaleEvent(percent: number): void {
  if (typeof window === "undefined") return;
  window.dispatchEvent(
    new CustomEvent(JOINT_MARKER_SCALE_EVENT, {
      detail: { percent },
    })
  );
}

export function getJointMarkerScalePercent(): number {
  return currentJointMarkerScalePercent;
}

export function readJointMarkerScalePercent(): number {
  if (typeof window === "undefined") return currentJointMarkerScalePercent;
  try {
    const raw = window.localStorage.getItem(JOINT_MARKER_SCALE_STORAGE_KEY);
    if (raw == null) return currentJointMarkerScalePercent;
    currentJointMarkerScalePercent = clampJointMarkerScalePercent(Number(raw));
    return currentJointMarkerScalePercent;
  } catch {
    return currentJointMarkerScalePercent;
  }
}

export function dispatchJointMarkerScalePercent(percent: number): void {
  const next = clampJointMarkerScalePercent(percent);
  currentJointMarkerScalePercent = next;
  try {
    if (typeof window !== "undefined") {
      window.localStorage.setItem(JOINT_MARKER_SCALE_STORAGE_KEY, String(next));
    }
  } catch {
    // Best-effort preference persistence; still notify the live UI below.
  }
  dispatchJointMarkerScaleEvent(next);
  getProjectSaveActions().markProjectDirty();
}

export function applyProjectJointMarkerScalePercent(percent: number): void {
  const next = clampJointMarkerScalePercent(percent);
  currentJointMarkerScalePercent = next;
  dispatchJointMarkerScaleEvent(next);
}
